/* eslint-disable react/no-danger -- when updating this component, consider replacing dangerous jsx properties */
import React from 'react';

import { expValEquals } from '@confluence/feature-experiments';
import { useRenderServerPlaceholder } from '@confluence/ssr-utilities/entry-points/useRenderServerPlaceholder.ts';

// Get preloaded WRM resources from window.__WRM_RESOURCES__ if in SSR environment or page is SSR rendered
function getWrmResources(renderServerPlaceholder: boolean) {
	if (
		(renderServerPlaceholder || window?.__SSR_RENDERED__) &&
		window?.__WRM_RESOURCES__?.preloaded
	) {
		return window.__WRM_RESOURCES__ ?? null;
	}
	return null;
}

export type LegacyMacroDefaultWrmRendererComponentProps = {
	wrmType: 'css' | 'js';
	renderComplete?: boolean;
};

const LegacyMacroDefaultWrmRendererComponent: React.FC<
	LegacyMacroDefaultWrmRendererComponentProps
> = ({ wrmType }) => {
	const renderServerPlaceholder = useRenderServerPlaceholder();
	const wrmResources = getWrmResources(renderServerPlaceholder);
	const wrmCss = wrmResources ? (wrmResources.css ?? '') : '';
	const renderCss = wrmType === 'css' && wrmCss;

	if (!renderCss) {
		return null;
	}

	return (
		<>
			{renderCss ? (
				<div
					data-testid="legacy_wrm_css"
					dangerouslySetInnerHTML={{ __html: wrmCss }}
					// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
					style={{ display: 'none' }}
				/>
			) : null}
		</>
	);
};

export type LegacyMacroDefaultWrmRendererProps = LegacyMacroDefaultWrmRendererComponentProps;

export const LegacyMacroDefaultWrmRenderer: React.FC<LegacyMacroDefaultWrmRendererProps> = (
	props,
) => {
	if (!expValEquals('confluence_preload_default_wrm_css', 'isEnabled', true)) {
		return null;
	}
	return <LegacyMacroDefaultWrmRendererComponent {...props} />;
};
